import React, { useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import { Col, Nav, Row } from 'react-bootstrap'
import styles from './style.module.scss'
import useWindowSize from '@shared/hooks/windowSize'
const SinglePlayerPick = dynamic(() => import('../singlePlayerPick'))

const PlayerPicks = ({ fantasystyles, playerPicksData }) => {
  const [width] = useWindowSize()
  const [selected, setSelected] = useState('aCVCFan')

  return (
    <section className={`${styles.playerPicks} mt-3`} id="cVc">
      <Nav className={`${styles.navTab} d-flex d-xl-none equal-width-nav mb-3`} variant="pills">
        <Nav.Item>
          <Nav.Link className={`${styles.tab} nav-link ${selected === 'aCVCFan' && 'active'}`} onClick={() => setSelected('aCVCFan')}>
            {'Captains'}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            className={`${styles.tab} nav-link ${selected === 'aTopicPicksFan' && 'active'}`}
            onClick={() => setSelected('aTopicPicksFan')}>
            {'Top Players'}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            className={`${styles.tab} nav-link ${selected === 'aBudgetPicksFan' && 'active'}`}
            onClick={() => setSelected('aBudgetPicksFan')}>
            {'Budget'}
          </Nav.Link>
        </Nav.Item>
      </Nav>
      {width > 1199 ? (
        <Row className="">
          <Col md={6} lg={6} xl={4}>
            {playerPicksData?.aCVCFan && playerPicksData?.aCVCFan?.length && <h3 className="small-head mb-3">{'Captains'}</h3>}
            <div className="d-flex flex-column">
              {playerPicksData?.aCVCFan?.map((captainData, index) => (
                <SinglePlayerPick type="captains" styles={styles} key={index} data={captainData} />
              ))}
            </div>
          </Col>
          <Col md={6} lg={6} xl={4}>
            {playerPicksData?.aTopicPicksFan && playerPicksData?.aTopicPicksFan?.length && (
              <h3 className="small-head mb-3">{'Top Players'}</h3>
            )}
            <div className="d-flex flex-column">
              {playerPicksData?.aTopicPicksFan?.map((topPickData, index) => (
                <SinglePlayerPick styles={styles} key={index} data={topPickData} />
              ))}
            </div>
          </Col>
          <Col md={6} lg={6} xl={4}>
            <Row className="d-flex flex-column">
              {playerPicksData?.aBudgetPicksFan && playerPicksData?.aBudgetPicksFan?.length && (
                <h3 className="small-head mb-3">{'Budget Players'}</h3>
              )}
              {playerPicksData?.aBudgetPicksFan?.map((budgetData, index) => (
                <SinglePlayerPick styles={styles} key={index} data={budgetData} />
              ))}
            </Row>
          </Col>
        </Row>
      ) : (
        <div className="d-flex flex-column">
          {playerPicksData?.[selected]?.map((data, index) => (
            <SinglePlayerPick type={selected === 'aCVCFan' ? 'captains' : null} styles={styles} key={index} data={data} />
          ))}
        </div>
      )}
    </section>
  )
}

PlayerPicks.propTypes = {
  fantasystyles: PropTypes.any,
  playerPicksData: PropTypes.object,
  playerData: PropTypes.array
}

export default PlayerPicks
